// src/pages/SoundsPage.js
import React from 'react';
import { useSoundsData } from '../hooks/useSoundsData';
import Pagination from '../components/Pagination';
import LoadingSpinner from '../components/common/LoadingSpinner';
import FixedSoundPlayer from '../components/sounds/FixedSoundPlayer';
import TextModal from '../components/sounds/TextModal';
import QualityAssessmentModal from '../components/quality/QualityAssessmentModal';

const SoundsPage = () => {
  const {
    // Данные
    sounds,
    projects,
    totalRecords,
    pagination,
    isSuperuser,
    // Фильтры
    filters,
    dateFilters,
    tempTextValues,
    tempDateValues,
    // Функции анализа
    isInSelection,
    handleToggleSelection,
    // Обработчики
    handleTextChange,
    handleTextBlur,
    handleTextKeyDown,
    handleFilterChange,
    handleDateChange,
    handleDateBlur,
    handleToday,
    handleYesterday,
    resetFilters,
    isFetching,
    // Пагинация
    currentPage,
    setCurrentPage,
    start,
    end,
    // Функции
    handleDownloadSound,
    handleExport,
    // Глобальные состояния
    activeSoundId,
    setActiveSoundId,
    activeTextSoundId,
    setActiveTextSoundId,
    handleHasAssessmentChange,
  } = useSoundsData();

  // Состояние для управления модальным окном оценки
  const [activeAssessmentSoundId, setActiveAssessmentSoundId] = React.useState(null);
  const [assessmentData, setAssessmentData] = React.useState(null);
  const [isAssessmentLoading, setIsAssessmentLoading] = React.useState(false);
  console.log("sounds: ", sounds)
  if (isFetching) {
    return (
        <div className="main-content">
          <div className="analytics-header mb-4">
            <h1>Звонки</h1>
          </div>
          <div className="mb-3">
            <button className="btn btn-success btn-sm" disabled>
              📥 Экспорт
            </button>
          </div>

          {/* === Поля дат (задизейблены) === */}
          <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px'}}>
            <div className="form-analytics-search-item">
              <label className="form-label">Дата и время (от):</label>
              <input
                  type="datetime-local"
                  name="date_filter_from"
                  className="form-control form-control-sm"
                  disabled
                  step="1"
              />
            </div>
            <div className="form-analytics-search-item">
              <label className="form-label">Дата и время (до):</label>
              <input
                  type="datetime-local"
                  name="date_filter_to"
                  className="form-control form-control-sm"
                  disabled
                  step="1"
              />
            </div>
            <div className="form-analytics-search-btn">
              <button type="button" className="btn btn-secondary btn-sm" disabled>
                Сброс
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered table-striped-columns table-sounds mt-4">
              <thead>
              <tr>
                <th>ID</th>
                <th>Проект</th>
                <th>Дата</th>
                <th>Время</th>
                <th>Телефон</th>
                <th>ФИО</th>
                <th>
                  Длительность
                  <br/>
                  <div style={{display: 'flex', gap: '5px', alignItems: 'center'}}>
                    <select
                        name="duration_op"
                        className="form-select form-select-sm"
                        value={filters.duration_op}
                        onChange={handleFilterChange}
                        style={{width: 'auto'}}
                    >
                      <option value="">все</option>
                      <option value=">">&gt;</option>
                      <option value="<">&lt;</option>
                      <option value=">=">&gt;=</option>
                      <option value="<=">&lt;=</option>
                    </select>
                    <input
                        type="number"
                        name="duration"
                        className="form-control form-control-sm"
                        value={filters.duration}
                        onChange={handleFilterChange}
                        placeholder="сек"
                        style={{width: '80px'}}
                    />
                  </div>
                </th>
                <th>Сторона сброса</th>
                <th>Канал поступления</th>
                <th>Линия</th>
                <th>Оценка</th>
                <th>Действие</th>
                <th>Текст</th>
                {isSuperuser && <th>Удаление</th>}
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colSpan="11" className="text-center py-4">
                  <LoadingSpinner text="Загружаем записи..."/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
    );
  }

  return (
      <div className="main-content">
        <div className="analytics-header mb-4">
          <h1>Звонки</h1>
          <div className="analytics-header-btm">
            <button type="button" className="btn btn-primary btn-sm me-2" onClick={handleToday}>
              Сегодня
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={handleYesterday}>
              Вчера
            </button>
          </div>
        </div>
        <hr/>

        <div className="mb-3">
          <button onClick={handleExport} className="btn btn-success btn-sm">
            📥 Экспорт
          </button>
        </div>

        <form id="filters-form" onSubmit={(e) => e.preventDefault()}>
          <input type="hidden" name="page" value="1"/>

          <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px'}}>
            <div className="form-analytics-search-item">
              <label className="form-label">Дата и время (от):</label>
              <input
                  type="datetime-local"
                  name="date_filter_from"
                  className="form-control form-control-sm"
                  value={tempDateValues.date_filter_from || dateFilters.date_filter_from}
                  onChange={handleDateChange}
                  onBlur={handleDateBlur}
              step="1"
            />
          </div>
          <div className="form-analytics-search-item">
            <label className="form-label">Дата и время (до):</label>
            <input
              type="datetime-local"
              name="date_filter_to"
              className="form-control form-control-sm"
              value={tempDateValues.date_filter_to || dateFilters.date_filter_to}
              onChange={handleDateChange}
              onBlur={handleDateBlur}
              step="1"
            />
          </div>
          <div className="form-analytics-search-btn">
            <button type="button" className="btn btn-secondary btn-sm" onClick={resetFilters}>
              Сброс
            </button>
          </div>
          <div className="form-analytics-search-btn">
            <button 
              type="button" 
              className={`btn btn-sm ${filters.has_assessment === 'true' ? 'btn-success' : 'btn-primary'}`}
              onClick={() => handleHasAssessmentChange?.(filters.has_assessment === 'true' ? '' : 'true')}
            >
              {filters.has_assessment === 'true' ? 'Все звонки' : 'С оценками'}
            </button>
          </div>
          <div className="form-analytics-search-btn">
            <button 
              type="button" 
              className={`btn btn-sm ${filters.has_assessment_in_analytics === 'true' ? 'btn-success' : 'btn-primary'}`}
              onClick={() => handleFilterChange({
                target: {
                  name: 'has_assessment_in_analytics',
                  value: filters.has_assessment_in_analytics === 'true' ? '' : 'true'
                }
              })}
            >
              {filters.has_assessment_in_analytics === 'true' ? 'Все звонки' : 'В аналитике'}
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-striped-columns table-sounds mt-4">
            <thead>
            <tr>
              <th>
                ID
                <br/>
                <input
                    type="number"
                    name="sound_id"
                    className="form-control form-control-sm mt-1"
                    value={tempTextValues.sound_id}
                    onChange={handleTextChange}
                    onBlur={handleTextBlur}
                    onKeyDown={handleTextKeyDown}
                    placeholder="Поиск по ID"
                />
              </th>
              <th>
                Проект
                <br/>
                <select
                    name="project"
                    className="form-select form-select-sm mt-1"
                    value={filters.project}
                    onChange={handleFilterChange}
                >
                  <option value="">Все проекты</option>
                  {projects.map(([id, name]) => (
                      <option key={id} value={id}>
                        {name}
                      </option>
                  ))}
                </select>
              </th>
              <th>Дата</th>
              <th>Время</th>
              <th>
                Телефон
                <br/>
                <input
                    type="text"
                    name="search_phone"
                    className="form-control form-control-sm mt-1"
                    value={tempTextValues.search_phone}
                    onChange={handleTextChange}
                    onBlur={handleTextBlur}
                    onKeyDown={handleTextKeyDown}
                    placeholder="Поиск"
                />
              </th>
              <th>
                ФИО
                <br/>
                <input
                    type="text"
                    name="search_operator"
                    className="form-control form-control-sm mt-1"
                    value={tempTextValues.search_operator}
                    onChange={handleTextChange}
                    onBlur={handleTextBlur}
                    onKeyDown={handleTextKeyDown}
                    placeholder="Поиск по ФИО"
                />
              </th>
              <th>
                Длительность
                <br/>
                <div style={{display: 'flex', gap: '5px', alignItems: 'center'}}>
                  <select
                      name="duration_op"
                      className="form-select form-select-sm"
                      value={filters.duration_op}
                      onChange={handleFilterChange}
                      style={{width: 'auto'}}
                  >
                    <option value="">Все</option>
                    <option value=">">&gt;</option>
                    <option value="<">&lt;</option>
                    <option value=">=">&gt;=</option>
                    <option value="<=">&lt;=</option>
                  </select>
                  <input
                      type="number"
                      name="duration"
                      className="form-control form-control-sm"
                      value={filters.duration}
                      onChange={handleFilterChange}
                      placeholder="сек"
                      style={{width: '80px'}}
                  />
                </div>
              </th>
              <th>
                Сторона сброса
                <br/>
                <select
                    name="stopside"
                    className="form-select form-select-sm mt-1"
                    value={filters.stopside}
                    onChange={handleFilterChange}
                >
                  <option value="">Все</option>
                  <option value="a">Клиент</option>
                  <option value="b">Оператор</option>
                </select>
              </th>

              <th>
                Канал поступления
                <br/>
                <select
                    name="side"
                    className="form-select form-select-sm mt-1"
                    value={filters.side}
                    onChange={handleFilterChange}
                >
                  <option value="">Все</option>
                  <option value="in">Входящие</option>
                  <option value="out">Исходящие</option>
                </select>
              </th>
              <th>
                Линия
                <br/>
                <input
                    type="text"
                    name="line"
                    className="form-control form-control-sm mt-1"
                    value={tempTextValues.line}
                    onChange={handleTextChange}
                    onBlur={handleTextBlur}
                    onKeyDown={handleTextKeyDown}
                    placeholder="поиск"
                />
              </th>
              <th>Оценка</th>
              <th>Действие</th>
              <th>Текст
                <br/>
                <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                  <select
                      name="text_search_scope"
                      className="form-select form-select-sm"
                      value={filters.text_search_scope}
                      onChange={handleFilterChange}
                  >
                    <option value="">Весь текст</option>
                    <option value="operator">Речь оператора</option>
                    <option value="client">Речь клиента</option>
                  </select>
                  <input
                      type="text"
                      name="text_search"
                      className="form-control form-control-sm"
                      value={tempTextValues.text_search}
                      onChange={handleTextChange}
                      onBlur={handleTextBlur}
                      onKeyDown={handleTextKeyDown}
                      placeholder="поиск в тексте"
                  />
                </div>
              </th>
              {isSuperuser && <th>Удаление</th>}
            </tr>
            </thead>
            <tbody>
            {sounds.length === 0 ? (
                <tr>
                  <td colSpan={isSuperuser ? 12 : 11} className="text-center text-muted py-4">
                    <strong>Записей по данным фильтрам не найдено</strong>
                  </td>
                </tr>
            ) : (
                sounds.map((sound) => (
                    <tr key={sound.id} valign="top">
                      <td data-label="ID">{sound.id}</td>
                      <td data-label="Проект">{sound.project_name}</td>
                      <td data-label="Дата">{sound.date}</td>
                      <td data-label="Время">{sound.time}</td>
                      <td data-label="Телефон">{sound.phone}</td>
                      <td data-label="Оператор">{sound.operator}</td>
                      <td data-label="Длительность">{sound.time_sound}</td>
                      <td data-label="Сторона">{sound.stopside === 'a' ? 'Клиент' : sound.stopside === 'b' ? 'Оператор' : sound.stopside}</td>
                      <td data-label="Канал">{sound.side === 'in' ? 'Входящий' : sound.side === 'out' ? 'Исходящий' : sound.side}</td>
                      <td data-label="Линия">{sound.line}</td>
                      <td data-label="Оценка">{sound.assessment_score? (sound.assessment_score*100).toFixed(2): sound.assessment_score===0 ? 0: '—'}</td>
                      <td data-label="Действия">
                        <div className="d-flex gap-1">
                          {/*<button*/}
                          {/*  onClick={() => handleDownloadSound(sound.id)}*/}
                          {/*  className="btn btn-sm btn-success me-2"*/}
                          {/*  type="button"*/}
                          {/*>*/}
                          {/*  Скачать*/}
                          {/*</button>*/}
                          {/*}*/}
                          {sound.has_audio && (
                              <button
                                  onClick={() => setActiveSoundId(sound.id)}
                                  className="btn btn-sm btn-primary"
                                  type="button"
                              >
                                Слушать
                              </button>
                          )}
                          {sound.assessment_id && (
                              <>
                                <button
                                    onClick={() => setActiveAssessmentSoundId(sound.id)}
                                    className="btn btn-sm btn-info me-1"
                                    type="button"
                                >
                                  Посмотреть оценку
                                </button>
                                <button
                                    onClick={() => handleToggleSelection(sound)}
                                    className={`btn btn-sm ${isInSelection(sound.assessment_id) ? 'btn-danger' : 'btn-success'}`}
                                    type="button"
                                >
                                  {isInSelection(sound.assessment_id) ? 'Убрать из анализа' : 'Добавить в анализ'}
                                </button>
                              </>
                          )}
                        </div>
                      </td>
                      <td data-label="Текст">
                        <button
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTextSoundId(sound.id);
                            }}
                            className="text-link-button"
                        >
                          {sound.text?.split('оператора: ').pop()?.substring(0, 40)}...
                        </button>
                      </td>


                      {isSuperuser && (
                          <td data-label="Удаление">
                            <a
                                href={`/api/delete_sound/${sound.id}`}
                                className="text-danger"
                                onClick={(e) => {
                                  if (!window.confirm('Удалить запись?')) e.preventDefault();
                                }}
                            >
                              Удалить
                            </a>
                          </td>
                      )}
                    </tr>
                ))
            )}
            </tbody>
          </table>
        </div>
        </form>

        {pagination.pages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={pagination.pages}
          onPageChange={setCurrentPage}
        />
      )}

      <div className="text-muted text-center mt-2">
        {totalRecords === 0 ? (
          <span>Записей не найдено</span>
        ) : (
          <>
            Показано {start}–{end} из {totalRecords.toLocaleString()} записей
          </>
        )}
      </div>

      {/* Закреплённый плеер */}
      <FixedSoundPlayer soundId={activeSoundId}  onClose={() => setActiveSoundId(null)} />

      {/* Модальное окно с текстом */}
      {activeTextSoundId && (
        <TextModal
          soundId={activeTextSoundId}
          onClose={() => setActiveTextSoundId(null)}
        />
      )}
      
      {/* Модальное окно с оценкой качества */}
      {activeAssessmentSoundId && (
        <QualityAssessmentModal
          isOpen={true}
          onClose={() => setActiveAssessmentSoundId(null)}
          sound_id={activeAssessmentSoundId}
        />
      )}
    </div>
  );
};

export default SoundsPage;
